import { Modal } from '@material-ui/core';
import React from 'react';
import CloseButton from '../CloseButton';
import componentsClasses from '@app/styles/components.module.css';
import classes from './styles.module.css';
import cls from 'classnames';
import { TagManager } from '@app/utils/tag-manager';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  onMakeAnotherOrderClick: () => void;
  orderWhatsappLink: string;
};

export default function OrderFinishedModal({ isVisible, onClose, onMakeAnotherOrderClick, orderWhatsappLink }: Props) {
  return (
    <Modal open={isVisible} className={classes.modal}>
      <div className={classes.content}>
        <main>
          <div>
            <img src="/static/order-finished.svg" className={classes.icon} />
          </div>
          <div>
            <h3 className={classes.title}>Obrigado!</h3>
            <p className={classes.message}>
              Seu pedido será enviado para o estabelecimento pelo WhatsApp. Clique no botão abaixo para enviar seu
              pedido.
            </p>
          </div>
          <a href={orderWhatsappLink} target="_blank" className={classes.whatsappLink}>
            <button className={cls(componentsClasses.successButton, classes.sendAgain, TagManager.Classes.Purchase)}>
              <span className={TagManager.Classes.Purchase}>Enviar meu pedido no WhatsApp</span>
            </button>
          </a>
          <button className={classes.makeAnotherOrder} onClick={onMakeAnotherOrderClick}>
            <span>Fazer um novo pedido</span>
          </button>
        </main>
      </div>
    </Modal>
  );
}
